<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn" v-if="[1, 5].includes(user.user_group_id)">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'escort',
      formInline: {
        iswork: 1,
      },
      formCtrl: [
        // {
        //   label: "车队长",
        //   keyName: "fleet",
        //   placeholder: "选择车队长",
        //   type: "select",
        //   options: [],
        //   className: "carcap",
        // },
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
        /*{
          label: "性别：",
          keyName: "sex",
          placeholder: "请选择性别",
          type: "select",
          options: [
            { label: '男', value: '男' },
            { label: '女', value: '女' },
          ],
        },
        {
          label: "出生年月：",
          keyName: "birthday",
          placeholder: "请选择出生年月",
          type: "date",
        },*/
      ],
      cols: [
        // { keyName: "fleetname", label: "车队长" },
        { keyName: "name", label: "姓名" },
        { keyName: "sex", label: "性别" },
        //{ keyName: "age", label: "年龄" },
        { keyName: "tel", label: "联系方式" },
        { keyName: "nation", label: "民族" },
        //{ keyName: "iswork", label: "状态" },
        { keyName: "province", label: "籍贯" },
        { keyName: "edu", label: "学历" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(`/staff/escortDetail?mode=view&id=${id}`);
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/staff/escortDetail?mode=edit&id=${id}`);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
        // {
        //   icon: "el-icon-link",
        //   title: "解绑",
        //   cb: ({ id }) => {
        //     this.$confirm("真的要解绑微信吗？", '提示', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'warning',
        //     })
        //       .then(() => {
        //         this.unBind(id);
        //       })
        //       .catch(() => {
        //         console.log('取消');
        //       });
        //   },
        // },
      ],
      baseParams: ['iswork'],
    };
  },
  computed: {
    ...mapState(['store']),
  },
  methods: {
    ...mapMutations(["setState"]),
    addItem() {
      this.$router.push(`/staff/escortDetail`);
    },
    unBind(id) {
      const url = `${this.baseUrl}/uplre`;
      const params = {
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg == 'success') {
            this.$message({
              type: 'success',
              message: '解绑成功!',
            });
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: '解绑失败，请稍后再试！',
            });
          }
        },
        err => {
          console.log(err);
          this.$message({
            type: 'error',
            message: '解绑失败，请稍后重试！'
          });
        });
    },
    setParams() {
      const { iswork } = this.$route.params;
      // const { idx, iswork } = this.$route.params;
      // const { fleet } = this.store;
      // console.log(idx, iswork, fleet)
      // if (fleet && fleet.length) {
      //   this.formInline.fleet = fleet[idx - 1].id;
      // }
      this.formInline.iswork = iswork;
      this.page = 1
      this.getList();
    },
    //车队长
    getCaptains() {
      this.loading = true;
      let url = `fixedpay/getfleet`;
      const params = {
        // userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ fleet }) => {
          this.loading = false;
          this.menu = fleet.map((v, i) => {
            return {
              name: v.nickname,
              path: `/staff/escort/table/${i + 1}`,
              fleet: v.id,
            };
          });
          if (this.menu.length) {
            // this.formCtrl[0].options = fleet.map((v) => {
            //   return {
            //     label: v.nickname,
            //     value: v.id,
            //   };
            // });
          }
          this.$forceUpdate();
          const { idx } = this.$route.params;
          this.menuIndex = `/staff/escort/table/${idx}`;
          // console.log(this.setState);
          this.setState({
            key: "fleet",
            value: fleet,
          });
          // console.log(this.menuIndex)
          // console.log(this.menu)
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams();
    },
  },
  created() {
    const { user_group_id } = this.user
    if (![1, 5].includes(user_group_id)) {
      this.btns.length = 1
    }
  },
  mounted() {
    // this.getCaptains();
    this.setParams();
  },
};
</script>
<style lang="less" scoped>
// /deep/ .carcap .el-input__inner {
//   width: 122px;
//   color: #303133;
//   border: 1px solid #F4F6F7;
//   background-color: #F4F6F7;
// }
// /deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
//   margin-right: 0px;
//   padding-right: 80px;
//   position: relative;

//   &::after {
//     position: absolute;
//     content: "";
//     right: 40px;
//     top: 6px;
//     width: 1px;
//     height: 28px;
//     overflow: hidden;
//     background-color: #EBEDF0;
//   }
// }
</style>